const PALETTES = {
  cyan: ['#22d3ee', '#34d399', 'rgba(34,211,238,.55)'],
  violet: ['#a78bfa', '#f472b6', 'rgba(167,139,250,.55)'],
  amber: ['#fbbf24', '#fb7185', 'rgba(251,191,36,.55)'],
  emerald: ['#34d399', '#22d3ee', 'rgba(52,211,153,.55)'],
};

export const ScoreRing = ({ value = 0, display, label, sublabel, palette = 'cyan', size = 200, testId }) => {
  const [from, to, glow] = PALETTES[palette] || PALETTES.cyan;
  const id = `ring-${palette}`;
  const r = 78, c = 2 * Math.PI * r;
  return (
    <div className="relative shrink-0" style={{ width: size, height: size }}>
      <div className="absolute inset-5 rounded-full blur-2xl" style={{ background: glow, opacity: 0.22 }} />
      <svg viewBox="0 0 200 200" className="relative w-full h-full -rotate-90">
        <circle cx="100" cy="100" r={r} fill="none" stroke="rgba(148,163,184,0.18)" strokeWidth="12" />
        <circle
          cx="100" cy="100" r={r} fill="none" strokeWidth="12" strokeLinecap="round"
          stroke={`url(#${id})`} strokeDasharray={c} strokeDashoffset={c - (c * value) / 100}
          style={{ transition: 'stroke-dashoffset 1.1s cubic-bezier(.22,1,.36,1)', filter: `drop-shadow(0 0 10px ${glow})` }}
        />
        <defs>
          <linearGradient id={id} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor={from} /><stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
        <span className="font-bold text-white tabular-nums leading-none"
          style={{ fontSize: Math.round(size * 0.24) }} data-testid={testId}>{display ?? value ?? '-'}</span>
        <span className="uppercase tracking-[0.18em] mt-1.5" style={{ color: from, fontSize: Math.max(9, Math.round(size * 0.055)) }}>{label}</span>
        {sublabel && <span className="text-[11px] text-slate-300 mt-1 leading-tight">{sublabel}</span>}
      </div>
    </div>
  );
};

export default ScoreRing;
